import { useCallback } from "react"
import { useMutation, UseMutationConfig } from "react-relay"
import { graphql } from "relay-runtime"
import { useCreateNewsMutation } from "@/modules/admin/news/services/__generated__/useCreateNewsMutation.graphql"

const mutation = graphql`
  mutation useCreateNewsMutation($input: CreateNewsInput!, $connections: [ID!]!) {
    createNews(input: $input) {
      news @prependNode(connections: $connections, edgeTypeName: "NewsEdge") {
        id
        isShowing
        ...NewsFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
const useCreateNewsNotificationMutation = () => {
  const [commit, isFlight] = useMutation<useCreateNewsMutation>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useCreateNewsMutation>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useCreateNewsNotificationMutation }
